module.exports = "<ion-footer class=\"common-footer\">\nNext <ion-icon size=\"large\" name=\"arrow-round-forward\"></ion-icon>\n</ion-footer>\n"